/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import get from 'lodash/get';
import size from 'lodash/size';
import times from 'lodash/times';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import Icon from '../Icon';
import Card from '../Card';
import Avatar from '../Avatar';
import ColToggler from './ColToggler';
import { isDesktop } from '../../utils/mobileHelpers';
import { QUESTION_TYPES } from '../../constants/props';
import handleValue from '../Survey/helpers/handleValue';
import ExportBtn from '../common/ProgramPopup/ExportBtn';
import { getRespondentData } from '../Survey/helpers/getRespondentData';
import { getSurveyAssignmentMethod } from '../../utils/survey/getSpecification';
import {
  makeString,
  TITLE_COLUMN,
  getSortedColumns,
  getFilteredColumns,
} from '../Survey/helpers/sorting';

import styles from './index.styl';

const DEFAULT_WIDTH = 240;
const getFirstColStyle = state => {
  if (isDesktop()) return null;

  const colWidth = state.wrapper.width / 2;
  const firstColWidth = colWidth < 1 ? DEFAULT_WIDTH : colWidth;

  return {
    width: `${firstColWidth}px`,
    maxWidth: `${firstColWidth}px`,
    minWidth: `${firstColWidth}px`,
  };
};

@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class Table extends PureComponent {
  static propTypes = {
    cols: PropTypes.object,
    userRow: PropTypes.object,
    totalRow: PropTypes.object,
    singleData: PropTypes.bool,
    isProviderPostVisitForm: PropTypes.bool,
    rows: PropTypes.arrayOf(PropTypes.object),
  };

  state = {
    narrow: false,
    wrapper: {
      width: -1,
    },
    table: {
      width: -1,
    },
    cell: {
      width: 48, // const from mockup
    },
    selectedCol: null,
  };

  componentWillMount() {
    this.defineState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.defineState(nextProps);
  }

  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.singleData) {
      this.handleFreeSpace(nextProps.cols, nextState);
    }
  }

  wrapper = null;

  getColIdentificator = col => get(col, 'id') || col;

  getCellValue(row, rawCol, val) {
    const { assignmentId } = this.props;

    const col = this.getColIdentificator(rawCol);
    const rawValue = handleValue(row[col], this.state.expanded, assignmentId);
    const value = get(rawValue, val);

    switch (val) {
      case 'totalScore': {
        return typeof value !== 'undefined' ? String(value) : rawValue;
      }
      case 'respondent': {
        return rawValue !== 'Respondent:'
          ? this.renderCard(rawValue)
          : rawValue;
      }
      case 'assignmentMethod': {
        return typeof value !== 'undefined'
          ? this.renderAssigmentInfo(rawValue, 'right-arrow')
          : rawValue;
      }
      default: {
        return value || rawValue;
      }
    }
  }

  renderAssigmentInfo = (data, iconName) => {
    const {
      intl: { formatMessage },
    } = this.props;
    const { expanded } = this.state;
    const { assignmentMethod, assigner } = data;
    if (!assignmentMethod) return null;

    const info = getSurveyAssignmentMethod({
      assignmentMethod,
      assigner,
      formatMessage,
      showDescription: true,
    });

    return (
      <Fragment>
        <Icon name={iconName} size={24} />
        {expanded && <span className="ml2">{info}</span>}
      </Fragment>
    );
  };

  renderCard = user => {
    const { expanded } = this.state;
    const {
      respondentName,
      respondentAvatar,
      role,
      teamName,
      teamOrganization,
    } = user ? getRespondentData(user) || {} : {};

    const primaryInfo = expanded ? (
      <Fragment>
        {respondentName}
        <span className="f11 fw4"> {role}</span>
      </Fragment>
    ) : null;

    const complementaryInfo =
      expanded && Boolean(teamName) ? (
        <Fragment>
          <Icon name="team" /> {teamName} ({teamOrganization})
        </Fragment>
      ) : null;

    if (user) {
      return (
        <Card
          className="inline-flex bg-transparent"
          text={{
            primary: primaryInfo,
            complementary: complementaryInfo,
          }}
          additionalContent={{
            left: (
              <Avatar
                children={respondentName}
                size={32}
                src={respondentAvatar}
              />
            ),
          }}
        />
      );
    }
  };

  defineState(props) {
    const expanded = !!props.singleData || !!this.state.selectedCol;
    const narrow = isDesktop() && expanded;

    this.setState({ narrow, expanded });
  }

  handleFreeSpace(cols, state) {
    const { wrapper, table, cell } = state;

    // Don't recalculate on collapsing
    if (wrapper.width === 0 || table.width === 0) return;

    const freeSpace = wrapper.width - table.width;
    const hasDummyCols =
      Object.keys(cols).findIndex(key => key.length > 1 && !key.trim().length) >
      -1;
    const narrow = freeSpace > 0 || hasDummyCols;

    this.setState({ narrow });

    if (freeSpace > 0) {
      // create dummy cols
      const cellsN = Math.ceil(freeSpace / cell.width);
      times(cellsN, index => {
        cols[makeString(index + 1)] = ' ';
      });
    }
  }

  isCellDanger(row, rawCol, param) {
    const col = this.getColIdentificator(rawCol);
    const rawValue = row[col];

    return get(rawValue, [param], false);
  }

  isColDanger(rawCol) {
    return get(rawCol, 'value') ? rawCol.triggered : false;
  }

  isCellPrimary(row, rawCol) {
    const col = this.getColIdentificator(rawCol);

    return typeof get(row, [col, 'totalScore']) !== 'undefined';
  }

  handleSelectColl(key) {
    const selectedCol = this.state.selectedCol === key ? null : key;

    this.setState(
      {
        selectedCol,
        narrow: isDesktop() && !!selectedCol,
        expanded: !!selectedCol,
      },
      () => {
        // scroll survey results into view
        if (!!selectedCol && !isDesktop()) {
          const el = this.wrapper;

          if (el) {
            const scrollWidth = el.scrollWidth - el.offsetWidth;
            el.scrollBy(scrollWidth, 0);
          }
        }
      },
    );
  }

  renderRowCols(row, cols, val) {
    return cols.map((column, i) => {
      const triggeredParam =
        val === 'totalScore' ? 'totalScoreTriggered' : 'triggered';
      const styleName = classNames('cell', {
        'cell--data': i > 0,
        'col--danger': this.isColDanger(column),
        'cell--danger': this.isCellDanger(row, column, triggeredParam),
        'cell--primary': this.isCellPrimary(row, column),
        'cell--bold': val === 'respondent' || 'assignmentMethod',
      });

      return (
        <td
          key={i}
          children={this.getCellValue(row, column, val)}
          className={classNames({ tc: i > 0 })}
          styleName={styleName}
          style={i === 0 ? getFirstColStyle(this.state) : null}
        />
      );
    });
  }

  renderComment(row, columns) {
    const comment =
      get(row, [TITLE_COLUMN, 'settings', 'name']) === QUESTION_TYPES.comment;
    const text = get(row, [TITLE_COLUMN, 'text']);
    const columnNumber = size(columns);

    if (comment) {
      return (
        <td styleName="text comment" colSpan={columnNumber}>
          {text}
        </td>
      );
    }
  }

  renderRows(rows, cols, val) {
    const columns = getFilteredColumns(cols, this.state.selectedCol);
    const rowStyle = classNames('row', {
      'row--primary': val === 'totalScore',
      'row--bold': val === 'respondent' || 'assignmentMethod',
    });

    return rows.map((row, index) => (
      <tr key={index} styleName={rowStyle}>
        {this.renderComment(row, columns) ||
          this.renderRowCols(row, columns, val)}
      </tr>
    ));
  }

  renderCols(cols) {
    const columns = getFilteredColumns(cols, this.state.selectedCol);

    // handle mobile table view
    const firstColStyle = getFirstColStyle(this.state);

    return columns.map((column, i) => {
      const canBeToggled = !this.props.singleData && column.value;
      const expanded = this.state.selectedCol === column.id;
      const styleName = classNames('cell cell--header', {
        'cell--data': i > 0,
        'cell--header__danger': column.triggered,
      });

      return (
        <th
          key={i}
          styleName={styleName}
          style={i === 0 ? firstColStyle : null}
        >
          <span styleName="cell--header__text">{column.value}</span>
          <If condition={canBeToggled}>
            <ColToggler
              expanded={expanded}
              onToggle={() => {
                this.handleSelectColl(column.id);
              }}
            />
          </If>
        </th>
      );
    });
  }

  render() {
    const { narrow, expanded } = this.state;
    const {
      cols,
      rows,
      totalRow,
      userRow,
      assignmentRow,
      isProviderPostVisitForm,
    } = this.props;
    const columns = getSortedColumns(cols);
    const wrapperStyleName = classNames('wrapper', {
      'wrapper--forNarrow': narrow || expanded,
    });
    const rowStyle = classNames('row', {
      'row--no-border': totalRow,
    });

    return (
      <Measure
        onMeasure={wrapper => {
          this.setState({ wrapper });
        }}
      >
        <Fragment>
          {this.state.expanded && this.props.exportPDF && (
            <div className={styles.exportButton}>
              <ExportBtn
                onClick={() =>
                  this.props.exportPDF({
                    openedAssignmentId: this.state.selectedCol,
                  })
                }
              />
            </div>
          )}
          <div styleName={wrapperStyleName} ref={node => (this.wrapper = node)}>
            <Measure
              onMeasure={table => {
                this.setState({ table });
              }}
            >
              <table styleName={classNames({ 'table--expanded': expanded })}>
                <thead>
                  <tr styleName={rowStyle}>{this.renderCols(columns)}</tr>
                </thead>
                <tbody>
                  {totalRow &&
                    this.renderRows([totalRow], columns, 'totalScore')}
                  {this.renderRows(rows, columns, 'value')}
                  {this.renderRows([userRow], columns, 'respondent')}
                  {!isProviderPostVisitForm
                    ? this.renderRows(
                        [assignmentRow],
                        columns,
                        'assignmentMethod',
                      )
                    : null}
                </tbody>
              </table>
            </Measure>
          </div>
        </Fragment>
      </Measure>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.jsx